module.exports = __webpack_public_path__ + "img/F-day_btn_music-off.e96c8c05.png";